import { Chip, Tooltip } from "@mui/material"
import type { FC } from "react"

import type { Company } from "@/graphql/codegen/graphql"

interface DistributorsCellProps {
  distributors?: Company[] | null
}

const MAX_VISIBLE_DISTRIBUTORS = 2

export const DistributorsCell: FC<DistributorsCellProps> = ({ distributors }) => {
  const visibleDistributors = distributors?.slice(0, MAX_VISIBLE_DISTRIBUTORS) ?? []
  const hiddenDistributors = distributors?.slice(MAX_VISIBLE_DISTRIBUTORS) ?? []
  const hasMore = hiddenDistributors.length > 0

  return (
    <div className='flex flex-wrap items-center gap-2'>
      {visibleDistributors.map((distributor) => (
        <Chip
          key={distributor.companyId}
          label={distributor.name}
          size='small'
          className='rounded bg-orange-100 text-xs text-blue-gray-800'
        />
      ))}
      {hasMore && (
        <Tooltip
          title={
            <div className='flex flex-col gap-1'>
              {hiddenDistributors.map((distributor) => (
                <div key={distributor.companyId}>{distributor.name}</div>
              ))}
            </div>
          }
        >
          <Chip label='...' size='small' className='rounded bg-orange-100 text-xs text-blue-gray-800' />
        </Tooltip>
      )}
    </div>
  )
}
